import { Base64 } from 'js-base64';

export default function parseJwt(jwt) {
  const splited = jwt.split('.')[1].replace('-', '+').replace('_', '/');

  return JSON.parse(Base64.decode(splited));
}
